// Nurture · toolbar of action buttons (regen / save / schedule / cancel).
// Pulled out so the toolbar can evolve without touching the email editor.
import React from "react";
import { Button } from "../ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader,
  AlertDialogTitle, AlertDialogTrigger,
} from "../ui/alert-dialog";
import { Loader2, Sparkles, Send, RefreshCw, Save, Ban } from "lucide-react";

export default function NurtureToolbar({
  status, canEdit, dirty,
  generating, saving, scheduling,
  onRegen, onRestart, onSave, onSchedule, onCancel,
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {status === "draft" && (
        <Button size="sm" variant="outline" onClick={onRegen} disabled={generating} data-testid="nurture-regen-btn">
          {generating ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
        </Button>
      )}
      {(status === "cancelled" || status === "completed") && (
        <Button size="sm" variant="outline" onClick={onRestart} disabled={generating} data-testid="nurture-restart-btn">
          {generating ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5 mr-1.5" />}
          Start new draft
        </Button>
      )}
      {canEdit && (
        <Button size="sm" variant="outline" onClick={onSave} disabled={!dirty || saving} data-testid="nurture-save-btn">
          {saving ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <Save className="w-3.5 h-3.5 mr-1.5" />}
          Save
        </Button>
      )}
      {status === "draft" && (
        <Button size="sm" onClick={onSchedule} disabled={scheduling} data-testid="nurture-schedule-btn" className="bg-accent text-accent-foreground hover:bg-accent/90">
          {scheduling ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : <Send className="w-3.5 h-3.5 mr-1.5" />}
          Schedule sequence
        </Button>
      )}
      {status === "scheduled" && (
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button size="sm" variant="outline" className="text-destructive hover:text-destructive" data-testid="nurture-cancel-btn">
              <Ban className="w-3.5 h-3.5 mr-1.5" /> Cancel
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>Cancel the nurture sequence?</AlertDialogTitle>
              <AlertDialogDescription>
                Day 0 has already been sent and cannot be unsent. The Day 3 and Day 7 emails will not be delivered.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel data-testid="nurture-cancel-no">Keep scheduled</AlertDialogCancel>
              <AlertDialogAction onClick={onCancel} data-testid="nurture-cancel-yes">Cancel sequence</AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
}
